import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
// import ListGroup from "./common/listGroup";

const GrabberChart = ({
  data,
  name,
  upperAbsolute,
  upperCheck,
  lowerCheck,
  lowerAbsolute,
}) => {
  const [series, setSeries] = useState([]);

  const [options, setOptions] = useState({
    chart: { id: "data", sparkline: { enabled: false } },
    colors: ["#2ecc71", "#3498db", "#f1c40f", "#e74c3c", "#9b59b6"],
    stroke: {
      curve: "straight",
    },
    tooltip: {
      theme: "dark",
      x: { show: true },
    },
    yaxis: {
      forceNiceScale: true,
      decimalsInFloat: 3,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "datetime",
      tooltip: { formatter: (d) => moment(d).format("Do MMM ha") },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
  });

  useEffect(() => {
    let annotations = { yaxis: [] };
    const setAnnotation = (value, label) => {
      let annotation;
      if (value) {
        annotation = {
          y: value,
          borderColor: "#e84118",
          label: {
            borderColor: "#e84118",
            style: {
              color: "#fff",
              background: "#e84118",
            },
            text: label,
          },
        };
      }
      return annotation;
    };
    const UAAnnotation = setAnnotation(upperAbsolute, "Upper Absolute");
    annotations.yaxis.push(UAAnnotation);
    const UCAnnotation = setAnnotation(upperCheck, "Upper Check");
    annotations.yaxis.push(UCAnnotation);
    const LCAnnotation = setAnnotation(lowerCheck, "Lower Check");
    annotations.yaxis.push(LCAnnotation);
    const LAAnnotation = setAnnotation(lowerAbsolute, "Lower Absolute");
    annotations.yaxis.push(LAAnnotation);

    setOptions((o) => {
      return { ...o, annotations };
    });
  }, [upperAbsolute, upperCheck, lowerCheck, lowerAbsolute]);

  useEffect(() => {
    const newSeries = [{ name, data: [] }];
    if (data.length === 0) return setSeries([]);
    data.map((d) =>
      newSeries[0].data.push({ x: d.REAL_DATETIME, y: d.PARAM_VALUE })
    );
    setSeries(newSeries);
  }, [name, data]);

  return <Chart options={options} series={series} type={"area"} height={400} />;
};

export default GrabberChart;
